import { render } from "./CardPayment.vue?vue&type=template&id=283147fa&scoped=true"
import script from "./CardPayment.vue?vue&type=script&lang=js"
export * from "./CardPayment.vue?vue&type=script&lang=js"

import "./CardPayment.vue?vue&type=style&index=0&id=283147fa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283147fa"]])

export default __exports__